import { jsx } from 'panel';
import { SelectEl } from 'common/components/select';
import { TooltipEl } from 'common/components/tooltip';
import { QueryBlockEl } from 'common/widgets/query-block';
import { Placement } from 'common/components/tooltip/types';
export function template() {
  return jsx("div", {
    sel: '.chart-header-container'
  }, jsx("div", {
    sel: '.chart-header-controls'
  }, this.attr("show-date-range-selector") || this.attr("show-time-comparison-menu") ? jsx("div", {
    sel: '.chart-header-report-controls'
  }, this.attr("show-date-range-selector") ? this.helpers.dateRangeSelectorRenderer() : null, this.attr("show-time-comparison-menu") ? jsx("div", {
    sel: '.time-comparison-container'
  }, this.attr("time-comparison-disabled-reason") ? jsx(TooltipEl, {
    attrs: {
      placement: Placement.Top
    }
  }, this.attr("time-comparison-disabled-reason")) : null, jsx(QueryBlockEl, {
    attrs: {
      type: "time-comparison",
      disabled: Boolean(this.attr("time-comparison-disabled-reason")),
      'max-data-history-days': this.attr("max-data-history-days"),
      selected: JSON.stringify(this.attr("comparison-date-range")),
      removable: Boolean(this.attr("comparison-date-range")),
      'date-range': JSON.stringify(this.attr("date-range")),
      'selector-type': "button",
      'project-id': this.attr("project-id"),
      'workspace-id': this.attr("workspace-id"),
      elref: "timeComparisonMenu",
      'project-as-of-date': this.attr("project-as-of-date"),
      'tooltip-data': this.attr("time-comparison-tooltip-data")
    },
    dataset: {
      key: "time-comparison"
    },
    on: {
      select: this.helpers.updateTimeComparison,
      remove: this.helpers.removeComparisonDateRange,
      track: this.helpers.captureTracking
    }
  })) : null) : null, this.helpers.hasSlot("report-controls") ? jsx("div", {
    sel: '.chart-header-report-controls-slot-container'
  }, jsx("slot", {
    attrs: {
      name: "report-controls"
    }
  })) : null, jsx("div", {
    sel: '.chart-header-chart-controls'
  }, this.helpers.hasSlot("chart-controls") ? jsx("div", {
    sel: '.chart-header-control-item'
  }, jsx("slot", {
    attrs: {
      name: "chart-controls"
    }
  })) : null, this.attr("value-representations").length ? jsx("div", {
    sel: '.chart-header-control-item'
  }, jsx(SelectEl, {
    key: 'value-representation-selector',
    attrs: this.helpers.valueRepresentationSelectorAttributes(),
    on: {
      change: this.helpers.updateValueRepresentation
    }
  })) : null, this.attr("date-units").length ? jsx("div", {
    sel: '.chart-header-control-item'
  }, jsx(SelectEl, {
    key: 'date-unit-selector',
    attrs: this.helpers.dateUnitSelectorAttributes(),
    on: {
      change: this.helpers.updateDateUnit
    }
  })) : null, this.attr("chart-types").length ? jsx("div", {
    sel: '.chart-header-control-item'
  }, jsx(SelectEl, {
    key: 'chart-type-selector',
    attrs: this.helpers.chartSelectorAttributes(),
    on: {
      change: this.helpers.updateChartType
    },
    props: {
      contextPanelTransform: this.helpers.contextPanelTransform
    }
  })) : null, this.helpers.hasSlot("advanced-chart-controls") ? jsx("div", {
    sel: '.chart-header-control-item'
  }, jsx("slot", {
    attrs: {
      name: "advanced-chart-controls"
    }
  })) : null)));
}